import { Bell, Building2, Compass, Monitor, PanelsTopLeft, UserCog } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/kit";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { AccountSection } from "../ui/AccountSection";
import { AppearanceSection } from "../ui/AppearanceSection";
import { HotelBrandingSection } from "../ui/HotelBrandingSection";
import { LayoutSection } from "../ui/LayoutSection";
import { NotificationsSection } from "../ui/NotificationsSection";
import { OnboardingSection } from "../ui/OnboardingSection";

const personalTabs = [
  { value: "account", label: "ບັນຊີ", icon: UserCog },
  { value: "appearance", label: "ຮູບລັກສະນະ", icon: Monitor },
  { value: "notifications", label: "ການແຈ້ງເຕືອນ", icon: Bell },
  { value: "layout", label: "ໂຄງຮ່າງ", icon: PanelsTopLeft },
  { value: "onboarding", label: "ການແນະນຳ", icon: Compass },
] as const;

export function SettingsPage() {
  const canManageHotel = useActionPermission(["users:update"]);

  return (
    <>
      <Header />

      <Main>
        <div className="mb-4">
          <h2 className="font-bold text-2xl tracking-tight">ການຕັ້ງຄ່າ</h2>
          <p className="text-muted-foreground">
            ຈັດການບັນຊີ, ຮູບລັກສະນະ ແລະ ການຕັ້ງຄ່າສ່ວນຕົວຂອງທ່ານ.
          </p>
        </div>

        <Tabs defaultValue="account" className="gap-6">
          <TabsList className="h-auto flex-wrap justify-start">
            {personalTabs.map(({ value, label, icon: Icon }) => (
              <TabsTrigger key={value} value={value}>
                <Icon className="size-4" />
                {label}
              </TabsTrigger>
            ))}
            {canManageHotel ? (
              <TabsTrigger value="hotel">
                <Building2 className="size-4" />
                ໂຮງແຮມ
              </TabsTrigger>
            ) : null}
          </TabsList>

          <TabsContent value="account">
            <AccountSection />
          </TabsContent>
          <TabsContent value="appearance">
            <AppearanceSection />
          </TabsContent>
          <TabsContent value="notifications">
            <NotificationsSection />
          </TabsContent>
          <TabsContent value="layout">
            <LayoutSection />
          </TabsContent>
          <TabsContent value="onboarding">
            <OnboardingSection />
          </TabsContent>
          {canManageHotel ? (
            <TabsContent value="hotel">
              <HotelBrandingSection />
            </TabsContent>
          ) : null}
        </Tabs>
      </Main>
    </>
  );
}
